import React, { useMemo } from 'react';
import { IRequestContext } from '@msdyn365-commerce/core';
import { AttributeValue, ProductPrice } from '@msdyn365-commerce/retail-proxy';
import { buildProductBadgeUrl, findAllAttributes, findAttributeValue } from '../../../../common/utilities/productListExtensionHelpers';

const ProductBadge = ({
    attributeValues,
    productPrice,
    requestContext
}: {
    attributeValues?: AttributeValue[];
    requestContext: IRequestContext;
    productPrice?: ProductPrice;
}) => {
    const discountAmount = productPrice?.DiscountAmount;
    if (discountAmount && discountAmount > 0) {
        process.env.NODE_ENV === 'development' && console.log('onsale', 'show', discountAmount);
        const badgeUrl = buildProductBadgeUrl(requestContext.locale, 'on_sale', requestContext.apiSettings.baseImageUrl, '_PDP');
        return <img className='msc-product__badge msc-product__badge--detail hei-badge' src={badgeUrl} alt=''></img>;
    }

    const badgeValue = useMemo(() => {
        if (discountAmount && discountAmount > 0) {
            process.env.NODE_ENV === 'development' && console.log('onsale', 'show', discountAmount);
            return 'on_sale';
        }

        const badgeAttributeArray = findAllAttributes(attributeValues, 'Product Badge Status');
        if (badgeAttributeArray) {
            for (const attr of badgeAttributeArray) {
                const badgeValue = findAttributeValue(attr);
                if (badgeValue && typeof badgeValue === 'string' && badgeValue.toLowerCase() !== 'none') {
                    return badgeValue;
                }
            }
        }

        return '';
    }, [attributeValues, discountAmount]);

    if (badgeValue) {
        const badgeUrl = buildProductBadgeUrl(requestContext.locale, badgeValue, requestContext.apiSettings.baseImageUrl, '_PDP');
        const badgeName = badgeValue.replace(/_/, ' ');
        return <img className='msc-product__badge msc-product__badge--detail hei-badge' src={badgeUrl} alt={badgeName} />;
    }

    return null;
};

export { ProductBadge };
